import React from "react";
import "./DrawVisualization.css";

const COLOR_MAP = {
  red: "#ef4444",
  blue: "#3b82f6",
  green: "#22c55e",
  yellow: "#eab308",
};

function DrawVisualization({ drawState }) {
  if (!drawState) return null;

  const {
    counts = {},
    draw_history = [],
    tick = 0,
    unique_leader,
    lead_changes_so_far = 0,
    draws_remaining_in_bag = 40,
    is_terminal = false,
  } = drawState;

  return (
    <div className="draw-visualization">
      <div className="draw-header">
        <span className="draw-tick">
          Tick {tick}/40
        </span>
        <span className="draw-remaining">
          {draws_remaining_in_bag} balls remaining
        </span>
        {unique_leader && (
          <span
            className="draw-leader"
            style={{ color: COLOR_MAP[unique_leader] || "#888" }}>
            Leader: {unique_leader}
          </span>
        )}
        <span className="draw-lead-changes">
          Lead changes: {lead_changes_so_far}
        </span>
        {is_terminal && <span className="draw-terminal">FINAL</span>}
      </div>

      <div className="draw-balls">
        {draw_history.map((color, i) => (
          <div
            key={i}
            className="draw-ball"
            style={{ backgroundColor: COLOR_MAP[color] || "#888" }}
            title={`Draw ${i + 1}: ${color}`}
          />
        ))}
      </div>

      <div className="draw-counts">
        {Object.entries(counts).map(([color, count]) => (
          <div key={color} className="draw-count-item">
            <div className="draw-count-label" style={{ color: COLOR_MAP[color] }}>
              {color}
            </div>
            <div className="draw-count-bar-wrapper">
              <div
                className="draw-count-bar"
                style={{
                  width: `${(count / 10) * 100}%`,
                  backgroundColor: COLOR_MAP[color],
                }}
              />
            </div>
            <div className="draw-count-value">{count}/10</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DrawVisualization;
